export default __webpack_public_path__ + "static/media/Endscenario-3.5d4cfe90.png";